// extracted by mini-css-extract-plugin
export default {"imagePreview":"ImagePreview_imagePreview__DXf-V","image":"ImagePreview_image__1Y2-n"};